declare var require: any;

import { Component, ChangeDetectorRef, Input, HostListener, Inject, ViewChild, ElementRef, ViewEncapsulation, DoCheck, OnDestroy } from '@angular/core'
import { Path } from '../../path/path-v2.model'
import { Question } from '../../question/question.model'
import { AppState } from '../../app.service'

import { SessionService } from '../../session/session.service'
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router'
import { HomeV5Service } from '../home-v5/home-v5.service'
import { ReplyService } from '../../reply/reply.service'
import { User } from '../../user/user.model'
import { StatService } from '../../stat/stat.service'
import { CordovaService } from '../../cordova.service'
import { MobileChatServiceService } from './mobile-chat-service.service'
import { AlertUserLikeListComponent } from '../../alert-user-like-list/alert-user-like-list.component'
import { zoomInUpAnimation, slideInUpAnimation, bounceInAnimation, slideInLeftAnimation, slideInRightAnimation } from 'angular-animations'
import { ToastrService } from 'ngx-toastr'
import { TranslationService } from '../../translation/translation.service';
import { lang } from 'moment';
import { WINDOW } from '../../window.service';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/spinner.service';
import { AlertSupportComponent } from 'src/app/alert-support/alert-support.component';
import { Client } from 'src/app/client/client.model';
import { FullScreenFeedComponent } from 'src/app/full-screen-feed/full-screen-feed.component';
import { FullScreenRoutineComponent } from 'src/app/full-screen-routine/full-screen-routine.component';
import { AnalyticsServiceService } from 'src/app/services/analytics-service.service';
import { I18n } from 'src/app/i18n.service';
import { ModalController, Platform } from '@ionic/angular';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import mixpanel from 'mixpanel-browser';
import { expandOnEnterAnimation, slideOutRightAnimation } from 'angular-animations';
import { AnimationsService } from 'src/app/shared/animations.service';
import { HomeUiService } from 'src/app/new-design/home-ui.service';
import { KyperDataApiService } from 'src/app/services/kyper-data-api.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';

declare var $: any;

@Component({
  selector: 'first90-mobile-chat-board',
  templateUrl: './mobile-chat-board.component.html',
  styleUrls: ['./mobile-chat-board.component.scss'],
  providers: [
    {
      provide: MAT_TABS_CONFIG,
      useValue: { animationDuration: '0ms' }
    }
  ],
  animations: [
    zoomInUpAnimation({ duration: 500, delay: 0 }),
    bounceInAnimation({ duration: 500, delay: 0 }),
    slideInUpAnimation({ duration: 500, delay: 0 }),
    slideInLeftAnimation({ duration: 300, delay: 0 }),
    slideInRightAnimation({ duration: 300, delay: 0 }),
    slideOutRightAnimation({duration: 500}),
    expandOnEnterAnimation({ duration: 400 }),
    trigger('expandOnEnter', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scaleY(0.95)', transformOrigin: 'top' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'scaleY(1)' }))
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class MobileChatBoardComponent implements DoCheck, OnDestroy {

  @Input() mode: string = "question";
  @Input() isHomeRoute: boolean;
  @Input() data;
  @ViewChild('h1')
  h1: ElementRef;
  @ViewChild('h2')
  h2: ElementRef;
  @ViewChild('h3')
  h3: ElementRef;
  destroyed$ = new Subject<boolean>();
  leftState=false;
  rightState=false;
  path: Path;
  client: Client;
  showing = "questions";
  nameCB: string;
  nameCBST = `Post ideas, learnings or begin a discussion with your peers. You can also share articles, links, videos that help others along the path.`;
  sortBy: "recent";
  text: string;
  chatBoardVisible: boolean = true;
  isCreating: boolean = false;
  loading: boolean = false;
  scheduleDays: any[];
  activeQuestion: Question | false; // LUMBA-1306
  openQuestionFeed: Question | false; // LUMBA-1306
  activeQuestionDay: number;
  comments: any[] = []; // FIXME: This are ChatBoardComments
  chatBoard: Question;
  scheduleDay: number;
  questions: Question[];
  habits: any;
  fixedQuestion: Question;
  task: string;
  isdailyQuestion: boolean;
  isAllQuestion: boolean;
  isChartBoard: boolean;
  isPostFeeds: boolean = false;
  level_1_replies: any;
  feedsList: any[] = [];
  isLoading=false;
  voteLoading: boolean = false;
  user: any;
  state: boolean = false;
  delay: number;
  duration: number;
  animationState = false;
  currentResponseDay = -1;
  animation = ['zoomInUp', 'slideInUp'];
  scrollPosition: any = null;
  intro: any;
  isMobile: any
  isRoutineV2: any;
  hasVoted: any;
  page: number
  isScrolledBottom: boolean = false
  isMobileWebIos = false;
  isMobileWeb=false;
  currentTab = 0;
  allLabel: string
  questionsLabel: string
  actionLabel: string
  habitLabel: string
  communityNotification: boolean
  notificationData: any
  startTime: any
  endTime: any
  showNoDataMsg: boolean = false
  stats: object
  options: [
    {
      label: 'Sliding Entrances',
      animations: ['slideOutRight']
    },
  ]
  dailyStepsArray
  postsList: any[] = [];
  noMorePosts = false;

  constructor(
    private appState: AppState,
    private cdRef: ChangeDetectorRef,
    private replyService: ReplyService,
    private sessionService: SessionService,
    private spinnerService: SpinnerService,
    private router: Router,
    private homev5Service: HomeV5Service,
    private statService: StatService,
    private homeUIService: HomeUiService,
    private cordovaService: CordovaService,
    private mobileService: MobileChatServiceService,
    private dialog: MatDialog,
    private translationService: TranslationService,
    private toasterService: ToastrService,
    private modalController: ModalController,
    private animationService: AnimationsService,
    private route: Router,
    private i18n: I18n,
    private platform: Platform,
    private analyticsService: AnalyticsServiceService,
    private kyperService: KyperDataApiService,
    //@Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window: Window
  ) {
    this.allLabel = this.i18n.t('ALL')
    this.allLabel= this.allLabel[0].toUpperCase() + this.allLabel.substr(1).toLowerCase()
    this.questionsLabel = this.i18n.t('QUESTIONS')
    this.questionsLabel= this.questionsLabel[0].toUpperCase() + this.questionsLabel.substr(1).toLowerCase()
    this.actionLabel = this.i18n.t('MICRO-ACTIONS')
    this.actionLabel= this.actionLabel[0].toUpperCase() + this.actionLabel.substr(1).toLowerCase()
    this.habitLabel = this.i18n.t('HABITS')
    this.habitLabel= this.habitLabel[0].toUpperCase() + this.habitLabel.substr(1).toLowerCase()
    this.client = this.appState.get('currentClient');
    this.path = this.appState.get("currentPath");
    this.scheduleDay = this.appState.get("currentScheduleDay");
    this.chatBoard = this.appState.get("currentChatBoard");
    // this.level_1_replies = this.chatBoard["replies"];
    // this.chatBoard.repliesEnabled = true;
    this.chatBoardVisible = this.path.enabledAttributes["community"];
    this.dailyStepsArray = this.appState.get('DailyStepsData')
    this.user = this.appState.get("currentUser");
    console.log("this.user", this.user);
    this.habits = this.fetchScreenTypeContent('habits');
    this.scrollPosition = this.appState.get("scrollPosition")
    this.page = this.appState.get('page')
    this.isMobile = this.appState.get('isMobile')
    if (!this.page) {
      this.page = 1
    }
    this.getPosts(this.path.id, false, null, this.page, true);
    this.startTime = new Date();
    // this.chatBoard.text = this.path.getCustomText("q_cb_st") || this.nameCBST;
    this.isRoutineV2 = this.appState.get("routineVersion")
    this.task = "dailyQuestion";
    this.isdailyQuestion = true;

    this.isChartBoard = false;
    this.loading = false;
    const questionsLoaded = this.appState.get("questionsLoaded");
    if (!questionsLoaded) {
      this.appState.set("questionsLoaded", true);
    } else {
      this.loading = true;
      // this.sessionService.refreshSession().subscribe(() => {
      //   this.loading = false;
      // });
    }

    this.isMobile = this.appState.get('isMobile')
  }
fetchScreenTypeContent(screentype) {
       let dailyStepsArray= this.appState.get("DailyStepsData");
    return dailyStepsArray
  .map(step => step?.[screentype])
  .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  ngOnInit() {
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.getUserTAGsList();
    if(!this.isHomeRoute && !this.isMobile) {
      this.currentTab =0
      console.log('here----'); 
    }
    else {
      this.currentTab = Number(localStorage.getItem('communityTab'));
       console.log('communityTab----'); 
    }
    this.analyticsService.setScreen(AnalyticsServiceService.COMMUNITY)
  }

  ngDoCheck(){
    //added if app is in BG & screen is community
    if (this.appState.get('isBackground') && this.feedsList?.length>0) {
    console.log('isBackground', this.appState.get('isBackground'));
    this.appState.set('isBackground', undefined)
      console.log('this.feedsList inside docheck:', this.feedsList);
      this.navigateToPost(this.feedsList)
      
    }
    
  }
  
  scroller() {
    setTimeout(() => {
      window.scroll(this.scrollPosition.x, this.scrollPosition.y);
    }, 1);
  }

  changeTab(evn) {
    const prevTab = this.currentTab;
    this.currentTab = evn.index;
    const tabGroup = document.querySelector('.my-com-tab');
    if (tabGroup) {
      if (evn.index > prevTab) {
        tabGroup.classList.remove('slide-left');   // forward → slide in from right
      } else {
        tabGroup.classList.add('slide-left');       // backward → slide in from left
      }
    }

    this.endTime = new Date();
    let timeDiff = this.endTime - this.startTime; // time difference in milliseconds
    let seconds = Math.floor(timeDiff / 1000); // convert to seconds
    let minutes = Math.floor(seconds / 60); // convert to minutes
    let hours = Math.floor(minutes / 60); // convert to hours
    let timeSpent = hours + ":" + minutes + ":" + seconds; // format the time spent
    mixpanel.track('Community- Tab change', {'Tabs active': this.currentTab == 0 ? 'All' : this.currentTab == 1 ? 'Questions': this.currentTab == 2 ? ' Micro-actions' : this.currentTab == 3 ? 'Habits' : '', 'time spent': timeSpent})
    localStorage.setItem('communityTab', this.currentTab.toString());
   //this.onChange();
  }

  getUserTAGsList() {
    if (!this.appState.get("userListLoaded")) {
      this.statService.getKyperUserParticipation().subscribe((response) => {
        this.appState.set("userListLoaded", true);
      });
    }
  }

  setActiveQuestion(day_num) {
    const question = this.dailyStepsArray[day_num-1].questions
    this.activeQuestionDay = day_num;
    if (question && day_num <= this.scheduleDay && question.enabled) {
      this.activeQuestion = question;
    } else {
      // LUMBA-1306
      this.activeQuestion = false;
    }
  }
  closePage(){
   
    this.modalController.dismiss();

  }

  toggleChatBoard() {
    if (this.isChartBoard) {
      this.isChartBoard = false;
    } else {
      this.isChartBoard = true;
    }
  }

  toggleSort(by) {
    this.sortBy = by;
  }

  openResponse(i) {
    if (i == this.currentResponseDay) {
      this.currentResponseDay = -1;
    } else {
      this.currentResponseDay = i;
    }
  }
  isOpen(i) {
    return this.currentResponseDay == i;
  }
  toggleButtons() {
    if (this.task == "dailyQuestion") {
      this.task = "allQuestion";
      this.isAllQuestion = true;
      this.isdailyQuestion = false;
    } else {
      this.task = "dailyQuestion";
      this.isAllQuestion = false;
      this.isdailyQuestion = true;
    }
  }

  closeCommunityFeeds() {
    this.bounceAnimation()
    if (this.isPostFeeds) {
      this.isPostFeeds = false;
    }
  }

  openPostFeed() {

    this.bounceAnimation()
    if (!this.isPostFeeds) {
      this.isPostFeeds = true
    }
  }

  totalLikes(items) {
    return items.reduce((a, b) => +a + +b.votesCount, 0);
  }

  async openQuestion(e,flag, singleTask, mode, isCommentSelect: boolean = null) {
    console.log('singleTask :', singleTask);
    mixpanel.track('Community-Post', {'post id': singleTask.id, 'post type': singleTask.type, 'post title': singleTask.title, 'post description': singleTask.commitmentStatement, 'post vote': singleTask.hasVoted})
    const scrollPosition = {
      x: e.pageX,
      y: e.pageY - 160
    }
    this.appState.set("scrollPosition", scrollPosition);
    console.log('scrollPosition :', scrollPosition);

    if (
      e.target.tagName.toLowerCase() === "a" &&
      e.target.target === "_blank"
    ) {
      if (this.cordovaService.onCordova) {
        e.stopPropagation();
        e.preventDefault();
        this.cordovaService.openLinkInBrowser(e.target.href);
      } else {
        window.open(e.target.href, "_blank");
      }
    } else {
      if (isCommentSelect || flag) {
        this.appState.set("commentClicked", true);
      }
      this.appState.set('singlePost', singleTask)
      console.log("🚀 ~ MobileChatBoardComponent ~ openQuestion ~ flag:", flag)
      if(flag) {
          const modal = await this.modalController.create({
            component: FullScreenFeedComponent,
            componentProps: {data:singleTask, focuseTextArea: true},
            cssClass: 'custom-modal',
            enterAnimation: this.animationService.slideInLeftEnterAnimation,
            leaveAnimation: this.animationService.SlideOutRightLeaveAnimation
           })  
           await modal.present()  
        }
        else {
          const modal = await this.modalController.create({
            component: FullScreenFeedComponent,
            componentProps: {data:singleTask, focuseTextArea: false},
            cssClass: 'custom-modal',
            enterAnimation: this.animationService.slideInLeftEnterAnimation,
            leaveAnimation: this.animationService.SlideOutRightLeaveAnimation,
           })  
           await modal.present()  
        }
    }
  }

  async openRoutine(e,flag, singleTask, mode, isCommentSelect: boolean = null) {
  console.log('singleTask :', singleTask);
    mixpanel.track('Community-post clicked', {'postId': singleTask.id, 'postTitle': singleTask.title, 'postDescription':singleTask.commitmentStatement})
    const scrollPosition = {
      x: e.pageX,
      y: e.pageY - 160
    }
    //this.closePage()
    this.appState.set("scrollPosition", scrollPosition);
    this.appState.set("routine_color", singleTask.routine_color);

    let selectedOption = null;
    if (
      e.target.tagName.toLowerCase() === "a" &&
      e.target.target === "_blank"
    ) {
      if (this.cordovaService.onCordova) {
        e.stopPropagation();
        e.preventDefault();
        this.cordovaService.openLinkInBrowser(e.target.href);
      } else {
        window.open(e.target.href, "_blank");
      }
    } else {
      if (isCommentSelect || flag) {
        this.appState.set("commentClicked", true);
      }

      selectedOption = this.appState.updateAcrossSteps(this.appState
        .get("DailyStepsData")
        ,"routineInfo", singleTask.routine_info_id, {
          votesCounts: singleTask.votescount
        });

      console.log("🚀 ~ MobileChatBoardComponent ~ openRoutine ~ selectedOption:", selectedOption)
      if (selectedOption) {
        const data = {
          routine: selectedOption,
          mode: mode,
        };

        this.appState.set("singleFeed", data);
      }

      console.log("🚀 ~ MobileChatBoardComponent ~ openRoutine ~ singleTask:", singleTask)
      if (singleTask) {
        const data = {
          singleRoutine: singleTask,
          mode: mode,
        };

        this.appState.set("singleHabit", singleTask)
        console.log("🚀 ~ MobileChatBoardComponent ~ openRoutine ~ data:", data)
        if(flag) {
          console.log('flag', flag)
          const modal = await this.modalController.create({
            component: FullScreenRoutineComponent,
            // animated: false,
            componentProps: {data:singleTask, focuseTextArea: true},
            cssClass: 'custom-modal',
            enterAnimation: this.animationService.slideInLeftEnterAnimation,
            leaveAnimation: this.animationService.SlideOutRightLeaveAnimation,

           })  
           await modal.present() 
        }
        else {
          console.log('flag 2', flag)
          const modal = await this.modalController.create({
            component: FullScreenRoutineComponent,
            // animated: false,
            componentProps: {data:singleTask, focuseTextArea: false},
            cssClass: 'custom-modal',
            enterAnimation: this.animationService.slideInLeftEnterAnimation,
            leaveAnimation: this.animationService.SlideOutRightLeaveAnimation,

           })  
           await modal.present() 
        }
      

       
      }

    }
  }

  openPost(e, post, isCommentSelect?: any) {
    const scrollPosition = {
      x: e.pageX,
      y: e.pageY - 160
    }
    this.appState.set("scrollPosition", scrollPosition);

    if (
      e.target.tagName.toLowerCase() === "a" &&
      e.target.target === "_blank"
    ) {
      if (this.cordovaService.onCordova) {
        e.stopPropagation();
        e.preventDefault();
        this.cordovaService.openLinkInBrowser(e.target.href);
      } else {
        window.open(e.target.href, "_blank");
      }
    } else {
      // console.log('')
      // let selectedOption = this.chatBoard.replies.find(
      //   (item) => item.id === post.id
      // );

      // if (isCommentSelect) {
      //   this.appState.set("commentClicked", true);
      // }
      // this.appState.set("singleFeed", selectedOption)
      // if (selectedOption !== null && this.appState.get('singleFeed')) {
      //   this.router.navigate(["/open-post-feed"]);
      // }
    }
  }

  reverseAndSortChaboard() {
    var sort_reply = this.level_1_replies.filter((event) => (event.replyLevel == 1 || event.level == 1));
    return sort_reply;
  }

  refresh() {
    return new Promise((resolve) => {
      // here to fetch the data and rerender the contents.
      this.appState.refreshMainComponent.emit();
      setTimeout(resolve, 0);
    });
  }

  getPosts(path_id, isTranslated, language, page, isFirstLoad, event: any = null) {
    if (isFirstLoad) { this.noMorePosts = false; }
    if (this.router.url === '/main/questions') {
      this.spinnerService.on();
      console.log('step 1', this.spinnerService)
    }
    let input = {
      path_id: path_id,
      page: page,
      user_language: language,
      is_translate: isTranslated
    }
    this.kyperService.getPostsList(input).subscribe(
      (response) => {
        console.log('postsList :', response.posts);
        if (this.router.url === '/main/questions' || (this.homeUIService.getModalStack()?.length > 0 && (this.homeUIService.getModalStack()[this.homeUIService.getModalStack()?.length - 1]?.component?.name == 'MobileChatBoardComponent' || this.homeUIService.getModalStack()[this.homeUIService.getModalStack()?.length - 1]?.name== 'MobileChatBoardComponent' ))) {
          this.spinnerService.off();
          console.log("stp 2")
        }
        this.isLoading=true;       

        const newPosts = response.posts ?? [];
        if (newPosts.length === 0) {
          this.noMorePosts = true;
          this.showNoDataMsg = this.feedsList.length === 0;
          if (event?.target) {
            event.target.complete();
            event.target.disabled = true;
          }
          return;
        }
        const prevLength = this.feedsList.length;
        this.feedsList = this.feedsList.concat(newPosts);
        const map = new Map();
        this.feedsList.forEach(item => map.set(item.id, item));
        this.feedsList = [...map.values()];
        this.appState.set("feeds_list", this.feedsList);
        if (this.feedsList.length === prevLength) {
          this.noMorePosts = true;
          if (event?.target) {
            event.target.complete();
            event.target.disabled = true;
          }
          return;
        }
        console.log('postsList :', this.feedsList);
        console.log('appstate postsList :', this.appState.get('feeds_list'));
        if(this.isLoading) {
          this.showNoDataMsg = true
        }
        event?.target.complete();
        console.log("step3")

        this.page = this.page + 1

        this.platform.ready().then(() => {
          if(this.platform.is('android') || this.platform.is('ios')){
            mixpanel.track("Feedslist loaded")
            this.navigateToPost(this.feedsList)
          }
        })
      },
      (error) => {
        this.isLoading=true;
        console.log("loading", this.isLoading)
        if (this.router.url === '/main/questions') {
          this.spinnerService.off();
        }        
        this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
      }
    );
  }

  toggleLike(reply, mode) {
    this.user = this.appState.get("currentUser");
    mixpanel.track('Community-Post like', {'post Id': reply.id, 'vote': reply.hasVoted, 'post type': reply.type})
    this.voteLoading = true;
    reply.hasVoted = !reply.hasVoted;
    // reply.votescount += reply.hasVoted ? 1 : -1;
    if(!reply.replyVotesCount) {
      reply.replyVotesCount =0
    }
    reply.replyVotesCount += reply.hasVoted ? 1 : -1
    console.log("this.mode", mode);
    if(reply.hasVoted)
    {
      reply.likes?.push(this.user?._data);

    }
    else {
      reply.likes?.forEach( (user, index) => {
        console.log("hser",user, this.user?._data)
        if(user?.id === this.user?._data?.id) 
        reply.likes?.splice(index,1);
      });

    }
    this.cdRef.detectChanges();
    let likesData = {
      // user_id: this.user.id,
      path_id: this.path.id,
      post_id: reply.id,
      screen_content_id: reply.screenContentId
    }
    this.kyperService.postKyperUserLikes(likesData)
    .pipe(takeUntil(this.destroyed$)).subscribe(
      (status) => {
        this.voteLoading = false;
        this.cdRef.detectChanges();

        if (mode) {
          let habit = this.appState.updateAcrossSteps(this.appState
            .get("DailyStepsData")
            ,mode + "s", reply.id, {
              hasVoted: status,
              votesCounts: status ? reply.votescount + 1 : reply.votescount - 1,
            });
        }
      },
      (error) => { 
        this.voteLoading = false;
        this.cdRef.detectChanges();
      }
    );
  }

  toggleLikeUserPost(reply, mode) {

    if (reply.user_id === this.user.id) {
      return false;
    }

    this.voteLoading = true;
    reply.hasVoted = !reply.hasVoted;
    reply.votes_count += reply.hasVoted ? 1 : -1;

    this.cdRef.detectChanges();
    this.replyService.voteReply(reply, mode).subscribe(
      (status) => {


        let habit = this.appState.updateAcrossSteps(this.appState
          .get("DailyStepsData")
          ,"chatBoardReplies", reply.id, {
            hasVoted: status,
            votesCount: status ? reply.votescount + 1 : reply.votescount - 1,
          });

        this.voteLoading = false;
        this.cdRef.detectChanges();
      },
      (error) => { },
      () => {
        this.voteLoading = false;
        this.cdRef.detectChanges();
      }
    );
  }

  bounceAnimation() {
    this.animationState = false;
    setTimeout(() => {
      this.animationState = !this.animationState;
    }, 100);
  }


  showLikeList(postId: number, mode: string) {
    this.mobileService.setIsLikeList(true)
    this.mobileService.setPostId(postId)
    this.mobileService.setMode(mode)
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
    this.homeUIService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');
  }
  async onLanguageSelected(lang) {
    console.log("selected langauge was", lang);
    let repliesTree =[]
    this.feedsList.forEach(obj => {
      if (obj.replies) {
        repliesTree = repliesTree.concat(obj.replies);
      }
    });
    const repliesIds = repliesTree.map((reply) => reply.id);
       this.path = this.appState.get("currentPath");

      this.translationService
        .loadRepliesTranslations(repliesIds, lang)
        .subscribe((translations) => {
          this.feedsList = this.feedsList.map(item => {
            // create a new copy of the item with updated replies
            const updatedReplies = item.replies?.map(reply => {
              const key = `Reply:${reply.id}`;
              return {
                ...reply,
                replyText: translations[key]?.text || reply.replyText
              };
            }) || [];
            return {
              ...item,
              replies: updatedReplies
            };
          });
           this.cdRef.detectChanges();
         this.appState.set("isNewLanguageSelected", true)
         this.appState.set("feeds_list", this.feedsList);
        });

  }

  showComment(mode: string, id) {
    console.log('modemodemode', mode, id)
  }
  showCommentList(mode: string, id: number) {

    const requestUserList = {
      id: id,
      path_id: this.path.id,
      mode: mode
    }
    this.mobileService.setIsLikeList(false)
    this.mobileService.setRequestUserList(requestUserList)
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
    this.homeUIService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');
  }


  deletePost(id) {

    this.mobileService.deletePost(id).subscribe(
      response => {
        console.log(response);
        this.toasterService.success(this.i18n.t('Post deleted successfully'))
        this.getPosts(this.path.id, false, null, this.page, true);
      },
      error => {
        console.log(error);
      }

    )

  }

  copyMessage(val: string, comment_id: number) {
    try {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.toasterService.success(this.i18n.t("Copied to clipboard!"));
      this.deletePost(comment_id)
    } catch {
      this.toasterService.warning(this.i18n.t("Not able to copy and delete!"));
    }
  }

  translate() {
    this.spinnerService.on()
    const path: Path = this.appState.get('currentPath')
    const repliesIds = this.chatBoard.replies.map(reply => reply.id)
  }
  goToQuestion() {
    var supportDialog = this.dialog.open(AlertSupportComponent);
    supportDialog.afterClosed().subscribe()
  }


  @HostListener("window:scroll", [])
  onWindowScroll() {
    const offset = this.window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (offset > 200) {
      this.isScrolledBottom = true
    } else {
      this.isScrolledBottom = false
    }
  }

  doInfinite(event) {
    console.log('doInfinite :');
    this.getPosts(this.path.id, false, null, this.page, false, event);
  }

  navigateToPost(feedsList: any) {
    this.communityNotification = this.appState.get('communityNotification')
    this.notificationData = this.appState.get('notificationData')
    let selectedOption = null;
    let postId: number
    if(typeof this.notificationData?.postId === 'string'){
      postId = parseInt(this.notificationData?.postId)
    }else{
      postId = this.notificationData?.postId
    }
    let screenContentId: number
    if(typeof this.notificationData?.screenContentId === 'string'){
      screenContentId = parseInt(this.notificationData?.screenContentId)
    }else{
      screenContentId = this.notificationData?.screenContentId
    }
    let data = {
      communityNotification: this.communityNotification,
      notificationData: this.notificationData,
      screenContentId: screenContentId
    }
    mixpanel.track('Community notificationData after clicking on notification', data);
    if (this.communityNotification && this.notificationData) {
      let singlePost = feedsList.find(item => item.screenContentId === screenContentId, 10)
      mixpanel.track('Community singlePost',  singlePost);
      let singleHabitPost = feedsList.find(item => item.habit_group_id === screenContentId, 10)
      mixpanel.track('Community singleHabitPost',  singleHabitPost);
      this.sessionService.removeNotificationBadge()
      localStorage.setItem('CommunityNotificationId', this.notificationData.id.toString())

      if (singlePost.type == 'Question' || singlePost.type == 'Action') {
        // selectedOption = this.appState.updateAcrossSteps(this.appState.get("DailyStepsData"),this.notificationData.mode + "s", singlePost.id, {
        //   votesCounts: singlePost.replyVotesCount
        // });
        // if (selectedOption) {
          const data = {
            question: selectedOption,
            modes: this.notificationData.mode,
          };
          this.appState.set("singleFeed", data)
          if(singlePost.type == 'Question'){
            localStorage.setItem('communityTab', '1');
          } else if(singlePost.type == 'Action'){
            localStorage.setItem('communityTab', '2');
          }
         // this.dialog.open(FullScreenFeedComponent)
         mixpanel.track('action/question data for notification',  singlePost);
          console.log('singlePost :', singlePost);
          this.appState.set("singlePost", singlePost)
          setTimeout(() => {
            mixpanel.track('opening full screen feed for question/action');
            this.homeUIService.openNextComponent(FullScreenFeedComponent, { data: singlePost })
          }, 700);
        
        // }
      }

      if (singlePost.type == 'Habit') {
        // selectedOption = this.appState.updateAcrossSteps(this.appState.get("DailyStepsData"),"habit", singleHabitPost.routine_info_id, {
        //     votesCounts: singleHabitPost.votescount
        //   });
        if (selectedOption) {
          const data = {
            routine: selectedOption,
            mode: 'habit',
          };
          this.appState.set("singleFeed", data);
        }
        mixpanel.track('singleHabitPost data for notification',  singleHabitPost);
        if (singleHabitPost) {
          const data = {
            singleRoutine: singleHabitPost,
            mode: 'habit',
          };
           mixpanel.track('Routing to the habit');
          this.appState.set("singleHabit", singleHabitPost)
          localStorage.setItem('communityTab', '3');
         // this.dialog.open(FullScreenRoutineComponent, {});
         this.homeUIService.openNextComponent(FullScreenRoutineComponent,{data:singleHabitPost})

        }
      }
      
    }
  }
   ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
   }
}
